export const ACTIVITY_HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000;

const defaultLastStampStore = new Map();

export function createTenantActivityHeartbeat({
  supabase,
  documentRef = typeof document === "undefined" ? null : document,
  timerApi = typeof window === "undefined" ? null : window,
  now = () => Date.now(),
  lastStampStore = defaultLastStampStore,
} = {}) {
  let intervalId = null;
  let userId = null;
  let activeClinicId = null;
  let inFlight = false;

  async function stampIfDue() {
    if (!supabase?.rpc || !userId || !activeClinicId || inFlight) return;
    if (documentRef?.visibilityState === "hidden") return;

    const currentMs = now();
    const lastStampMs = lastStampStore.get(userId);
    if (lastStampMs != null && currentMs - lastStampMs < ACTIVITY_HEARTBEAT_INTERVAL_MS) {
      return;
    }

    inFlight = true;
    try {
      const { error } = await supabase.rpc("stamp_user_activity", {
        p_clinic_id: activeClinicId,
      });
      if (!error) lastStampStore.set(userId, currentMs);
    } catch {
      // Activity stamping is operational telemetry; never block the app.
    } finally {
      inFlight = false;
    }
  }

  function onVisibilityChange() {
    if (documentRef?.visibilityState === "visible") {
      void stampIfDue();
    }
  }

  function start(nextContext = {}) {
    userId = nextContext.userId || null;
    activeClinicId = nextContext.activeClinicId || null;
    void stampIfDue();

    if (timerApi?.setInterval && !intervalId) {
      intervalId = timerApi.setInterval(() => {
        void stampIfDue();
      }, ACTIVITY_HEARTBEAT_INTERVAL_MS);
    }

    documentRef?.addEventListener?.("visibilitychange", onVisibilityChange);
  }

  function stop() {
    if (intervalId && timerApi?.clearInterval) {
      timerApi.clearInterval(intervalId);
    }
    intervalId = null;
    documentRef?.removeEventListener?.("visibilitychange", onVisibilityChange);
  }

  return { start, stop, stampIfDue };
}
